import type { FC } from 'react';
import React, { isValidElement } from 'react';

import type { IPublicProps } from './models';

export const PropsOverrider: FC<React.PropsWithChildren<IPublicProps>> = ({ children, props }) => {
    return isValidElement(children)
        ? React.cloneElement(children, {
              ...props,
          })
        : null;
};
